module.exports = __webpack_public_path__ + "img/duels.4df4583d.png";